import React from 'react'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'
import SkeletonElement from '../Skeleton/Skeleton'
import GoogleReviewCarousel from '../GalleryCarousel/GoogleReviewCarousel'
import SectionHeader from "../SectionHeader/SectionHeader";
import TrustpilotRatingStar from '../../../assets/images/icon_trustpilot.svg'
import GoogleLogo from '../../../assets/images/icon_google_star.webp'

const Container = styled.div`
  padding: 0;
  width: 100%;
  
  margin-bottom: 40px;
  
  @media screen and (max-width: 965px) {
  }

  @media screen and (max-width: 780px) {
  }
`
const Section = styled.div`
  &.paddin-right-none {
    padding-right: 0;
  }
`

const ReviewsText = styled.p`
  font-size: 14px;
  color: darkgray;
  margin: 0;

  display: flex;
  gap: 24px;
  justify-content: space-between;
  
  @media screen and (min-width: 48em) {
    justify-content: end;
  }
`

const ReviewsItem = styled.div`
  font-size: 14px;
  color: darkgray;
  margin: 0;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  
  span {
    font-size: 24px;
    color: #4D4D4D;
  }
  
  img {
    height: 16px;
    width: 16px;
    object-fit: contain;
  }
  
  div {
    display: flex;
    gap: 4px;
    align-items: center;
  }
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 40px;
  padding-right: 24px;
  
  @media screen and (min-width: 48em) {
    grid-template-columns: 60% 40%;
  }
  
  @media screen and (min-width: 64em) {
    padding-right: 40px;
    grid-template-columns: 70% 30%;
  }

  @media screen and (min-width: 90em) {
    padding-right: 80px;
  }
`

function TrustedReviewsBlock() {
  const [isLoading, setIsLoading] = React.useState(true)

  const data = useStaticQuery(graphql`
    query {
      contentfulComponentTrustedReviews {
        sectionTitle
        sectionSubtitle
        googleRating
        trustpilotRating
        googleLink
        trustpilotLink
        reviews {
          fullName
          dateOfReview
          rating
          comment {
            raw
          }
          type
          userPhoto {
            url
          }
        }
      }
    }
  `)

  const reviewsInfo = data?.contentfulComponentTrustedReviews || null
  const reviews = reviewsInfo?.reviews || []

  React.useEffect(() => {
    if (data) {
      setIsLoading(false)
    }
  }, [data])

  if (isLoading) return <SkeletonElement placeholder="Loading Trusted Reviews..." />

  if (!reviewsInfo || !reviews.length) return <></>

  return (
    <Section className="outer margin-80 paddin-right-none">
      <div className="inner">
        <Header>
          <SectionHeader
              headerCopy={reviewsInfo.sectionTitle}
              subTitle={reviewsInfo.sectionSubtitle}
          />
          <ReviewsText>
            <ReviewsItem>
              <span><b>{reviewsInfo.googleRating}</b></span>
              <div>
                {new Array(Math.round(reviewsInfo.googleRating)).fill(0).map((_, i) => (
                   <img key={i} src={GoogleLogo} alt="Google Star" loading="lazy" />
                ))}
              </div>
              <a rel="noreferrer" target="_blank" href={reviewsInfo.googleLink}>
                on Google Shopping
              </a>
            </ReviewsItem>
            <ReviewsItem>
              <span><b>{reviewsInfo.trustpilotRating}</b></span>
              <div>
                {new Array(Math.round(reviewsInfo.trustpilotRating)).fill(0).map((_, i) => (
                    <img key={i} src={TrustpilotRatingStar} alt="Trustpilot Star" loading="lazy" />
                ))}
              </div>
              <a rel="noreferrer" target="_blank" href={reviewsInfo.trustpilotLink}>
                on Trustpilot
              </a>
            </ReviewsItem>
          </ReviewsText>
        </Header>
        <Container>
          <GoogleReviewCarousel reviews={reviews} />
        </Container>
      </div>
    </Section>
  )
}

export default TrustedReviewsBlock
